
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';
export default {
  data: function () {
    return {
      hasInhouse: false,
      hasAvailable: false,
      Info: actions.GetDashboardinfo()
    };
  },
  methods: {
    OpenReservation(ReservationID) {
      try {
        app.f7.views.main.router.navigate({
          name: 'reservation-info',
          params: {
            id: ReservationID
          }
        });
      } catch (ex) {
        alert(ex);
      }
    }

  },
  on: {
    pageInit: async function (e, page) {
      var self = this;
      var $ = self.$;
      $(".searchbar-enable").on("click", async function (e) {
        app.f7.views.main.router.navigate('/search-inhouse/', {
          transition: 'f7-dive'
        });
      });
      var loginResult = await actions.LoginGetResult();
      $$(".currency-symbol").html(loginResult?.Currency);
      self.hasInhouse = self.Info.Inhouse?.Inhouse.length > 0 ? true : false;
      self.hasAvailable = self.Info.Inhouse?.Available.length > 0 ? true : false;
      self.$setState({
        hasInhouse: self.hasInhouse,
        hasAvailable: self.hasAvailable
      });
    }
  },
  id: '9adc910ca1',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page page-with-subnavbar" data-name=inhouse><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class="link back"><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'InHouse', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=right><a class="link icon-only searchbar-enable"><i class="icon f7-icons if-not-md">search</i> <i class="icon material-icons md-only">search</i></a></div></div></div><div class=subnavbar style="background-color: #222933;"><div class=subnavbar-inner><span class=row style="width: 100%;display: inline-block;position: absolute;text-align: center;top: -19px;font-size: 15px;left:0;">';
      r += Template7Helpers.t.call(ctx_1, 'sortby', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span><div class=row><div class="segmented segmented-strong" style=background-color:#40454cb8><a class="button tab-link tab-link-active" href=#InHouseID>In House</a> <a class="button tab-link" href=#AvailableInhouseID>Available</a> <span class=segmented-highlight></span></div></div></div></div><div class=page-content style="background-color: #F7F7F7;"><div class="row tab"><div class=tabs style=width:100%><div class="tab tab-active" id=InHouseID>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hasInhouse, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Info.Inhouse.Inhouse, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding takis" @click=OpenReservation(';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '); style="padding: 0 0 0 10px;margin: 10px;"><div class=event-color style="background-color: #D2CD3E"></div><div class=row><div class="col-80 flex" style="font-size: 15px;"><div style="font-weight:600;padding-bottom: 5px;">';
              r += c(ctx_3.Guest, ctx_3);
              r += ' <span class="badge color-blue Reservation">';
              r += c(ctx_3.SourceName, ctx_3);
              r += '</span></div><div class=col-100 style="display:flex;padding: 1px 0;">Res. cod. ';
              r += c(ctx_3.ResID, ctx_3);
              r += '</div><div class=row style="padding: 1px 0;"><div class="col-100 reservcode" style=display:flex; id=';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '>';
              r += c(ctx_3.RoomCategoryName, ctx_3);
              r += ' (';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' <span class=currency-symbol></span>)</div></div><div class=row><div class="col-100 reservcode" style=display:flex;>';
              r += c(ctx_3.Nights, ctx_3);
              r += ' Nights - ';
              r += c(ctx_3.Visitors, ctx_3);
              r += ' Guests - ';
              r += c(ctx_3.RoomsTotalBooked, ctx_3);
              r += ' Rooms</div></div><!-- <span>';
              r += c(ctx_3.Dates, ctx_3);
              r += ', Night ';
              r += c(ctx_3.Nights, ctx_3);
              r += ', Visitors:';
              r += c(ctx_3.Visitors, ctx_3);
              r += '</span> --><!-- ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsPaid, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span class="color-green">\n                        <p>Payed</p>\n                      </span>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span class="mycolor-red">\n                        <p>Unpayed</p> --><!-- ';
                  r += c(ctx_4.TotalPrice, ctx_4);
                  r += ' <span class="currency-symbol"></span>\n                      </span>\n                    ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' --></div><div class="col-20 flex" style="align-items: flex-end;"><span style=display:none><a class="button color-darkgrey popover-open" href=# data-popover=.my-popover><i class=material-icons>more_horiz </i></a></span><span class=color-darkgreen style="text-align: center;font-size:1.4em;"><b>';
              r += c(ctx_3.Room, ctx_3);
              r += '</b></span></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row mycenter" style="margin: auto; justify-content: center; margin-top: 12rem;"><span>No in house reservations today</span></div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class="tab tab" id=AvailableInhouseID>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.hasAvailable, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.Info.Inhouse.Available, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding takis" @click=OpenReservation(';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '); style="padding: 0 0 0 10px;margin: 10px;"><div class=event-color style="background-color: #D2CD3E"></div><div class=row><div class="col-80 flex" style="font-size: 15px;"><div style="font-weight:600;padding-bottom: 5px;">';
              r += c(ctx_3.Guest, ctx_3);
              r += ' <span class="badge color-blue Reservation">';
              r += c(ctx_3.SourceName, ctx_3);
              r += '</span></div><div class=col-100 style="display:flex;padding: 1px 0;">Res. cod. ';
              r += c(ctx_3.ResID, ctx_3);
              r += '</div><div class=row style="padding: 1px 0;"><div class="col-100 reservcode" style=display:flex; id=';
              r += c(ctx_3.ReservationID, ctx_3);
              r += '>';
              r += c(ctx_3.RoomCategoryName, ctx_3);
              r += ' (';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' <span class=currency-symbol></span>)</div></div><div class=row><div class="col-100 reservcode" style=display:flex;>';
              r += c(ctx_3.Nights, ctx_3);
              r += ' Nights - ';
              r += c(ctx_3.Visitors, ctx_3);
              r += ' Guests - ';
              r += c(ctx_3.RoomsTotalBooked, ctx_3);
              r += ' Rooms</div></div><!-- <span>';
              r += c(ctx_3.Dates, ctx_3);
              r += ', Night ';
              r += c(ctx_3.Nights, ctx_3);
              r += ', Visitors:';
              r += c(ctx_3.Visitors, ctx_3);
              r += '</span> --><!-- ';
              r += Template7Helpers.if.call(ctx_3, ctx_3.IsPaid, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span class="color-green">\n                        <p>Payed</p>\n                      </span>\n                      ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '\n                      <span class="mycolor-red">\n                        <p>Unpayed</p> --><!-- ';
                  r += c(ctx_4.TotalPrice, ctx_4);
                  r += ' <span class="currency-symbol"></span>\n                      </span>\n                    ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' --></div><div class="col-20 flex" style="align-items: flex-end;"><span style=display:none><a class="button color-darkgrey popover-open" href=# data-popover=.my-popover><i class=material-icons>more_horiz </i></a></span><span class=color-darkgreen style="text-align: center;font-size:1.4em;"><b>';
              r += c(ctx_3.Room, ctx_3);
              r += '</b></span></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="row mycenter" style="margin: auto; justify-content: center; margin-top: 12rem;"><span>No available reservations today</span></div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class="popover my-popover"><div class=popover-inner><div class=block><div class=row><div class=col-20><i class=material-icons>info</i></div><div class=col-80>Read</div></div><div class=row><div class=col-20><i class=material-icons>edit</i></div><div class=col-80>Edit</div></div><div class=row></div><div class=row></div><div class=row></div></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .event-color {
    position: absolute;
    left: 0;
    top: 0;
    width: 4px;
    height: 100%;
  }
`,
  styleScoped: false
};
    